<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ (type == 'review' ? $t('reviewAccount') : $t(type)) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile & !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row class="mt-1">
      <v-col class="d-flex py-0">
        <v-col
          cols="12"
          md="2"
          class="pe-0"
        >
          <v-select
            v-model="remain"
            :label="$t('remainType')"
            :items="remainItems"
            height="32"
            dense
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="pe-0"
        >
          <autocomplete
            v-model="fromFinancialYear"
            :title="$t('fromFinancialYear')"
            type="year"
            :value="fromFinancialYear"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="pe-0"
        >
          <autocomplete
            v-model="toFinancialYear"
            :title="$t('toFinancialYear')"
            type="year"
            :value="toFinancialYear"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="documentType"
          :title="$t('documentType')"
          type="documentType"
          :filter="true"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <v-select
          v-model="filterType"
          :label="$t('filter')"
          :items="filterTypeItems"
          height="32"
          dense
          outlined
          hide-details
          item-value="value"
          item-text="text"
        />
      </v-col>
      <v-col
        v-show="filterType == 'month'"
        cols="12"
        md="2"
        class="pe-0"
      >
        <template>
          <v-text-field
            id="fromIdMonth"
            v-model="fromMonth"
            :label="$t('from') + ' ' + $t('month')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="fromMonth"
            element="fromIdMonth"
            locale="fa,en"
            auto-submit
            type="year-month"
            format="jYYYY/jMM"
            :min="(fromFinancialYear ? fromFinancialYear.start_date : null)"
            :max="(toFinancialYear ? toFinancialYear.end_date : null)"
            simple
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
          />
        </template>
      </v-col>
      <v-col
        v-show="filterType == 'month'"
        cols="12"
        md="2"
        class="pe-0"
      >
        <template>
          <v-text-field
            id="toIdMonth"
            v-model="toMonth"
            :label="$t('until') + ' ' + $t('month')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="toMonth"
            element="toIdMonth"
            locale="fa,en"
            auto-submit
            type="year-month"
            format="jYYYY/jMM"
            :min="(fromFinancialYear ? fromFinancialYear.start_date : null)"
            :max="(toFinancialYear ? toFinancialYear.end_date : null)"
            simple
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
          />
        </template>
      </v-col>
      <v-col
        v-show="filterType == 'date'"
        cols="12"
        md="2"
        class="pe-0"
      >
        <template>
          <v-text-field
            id="fromId"
            v-model="fromDate"
            :label="$t('from') + ' ' + $t('date')"
            outlined
            dense
            clearable
          />

          <date-picker
            v-model="fromDate"
            element="fromId"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
            @close="setDate"
          />
        </template>
      </v-col>
      <v-col
        v-show="filterType == 'date'"
        cols="12"
        md="2"
        class="pe-0"
      >
        <template>
          <v-text-field
            id="toId"
            v-model="toDate"
            :label="$t('until') + ' ' + $t('date')"
            outlined
            dense
            clearable
          />

          <date-picker
            v-model="toDate"
            element="toId"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            :min="fromDate"
            auto-submit
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
            @close="setDate"
          />
        </template>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="group"
          title="group"
          type="group"
          :multiple="true"
          :solo="false"
          :dense="false"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="total"
          title="total"
          type="total"
          :multiple="true"
          :solo="false"
          :dense="false"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="given"
          title="given"
          type="given"
          :multiple="true"
          :solo="false"
          :dense="false"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="fin4"
          title="detail"
          type="detail"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="fin5"
          title="fin5"
          type="detail"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="fin6"
          title="fin6"
          type="detail"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-0"
      >
        <autocomplete
          v-model="branch"
          title="branch"
          type="branch"
          :filter="true"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="pe-2"
      >
        <v-btn
          block
          small
          color="primary"
          @click="getItems"
        >
          {{ $t('updateReport') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-0 mb-2">
      <v-col
        cols="12"
        class="py-0"
      >
        <v-chip-group
          v-model="level"
          active-class="primary--text"
          column
          mandatory
        >
          <v-chip
            v-for="levelitem in levelItems"
            :key="levelitem"
            label
            class="ms-0 me-1"
            small
            :value="levelitem"
          >
            {{ $t(levelitem) }}
          </v-chip>
          <v-chip
            v-shortkey="['f6']"
            label
            value="back"
            class="ms-0 me-1"
            small
            @shortkey="backLevel(level)"
          >
            {{ $t('backToUpLevel') }} (f6)
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0 mt-0"
    >
      <v-col
        class="mb-4 px-2 pt-0"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2 pt-0 border-datatable"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.row="{ item }">
          <div class="px-1">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + (typeForm == 'product' ? 'product':'service') +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user="{ item }">
          {{ item.user.firstname }} ( {{ item.user.lastname }} )
        </template>
        <template v-slot:item.reviewContent="{ item }">
          <v-btn
            text
            small
            @click="setLevel(item)"
          >
            {{ item.groupName }}
            {{ (level != 'group' ? ' / ' + item.totalName : '') }}
            {{ (level != 'group' && level != 'total' ? ' / ' + item.givenName : '') }}
            {{ (level != 'group' && level != 'total'&& level != 'given' && (level == 'detail' || level == 'fin5' || level == 'fin6') && item.fin4 ? ' / ' + item.fin4.name : '') }}
            {{ (level != 'group' && level != 'total'&& level != 'given' && (level == 'fin5' || level == 'fin6') && item.fin5 ? ' / ' + item.fin5.name : '') }}
            {{ (level != 'group' && level != 'total'&& level != 'given' && level == 'fin6' && item.fin6 ? ' / ' + item.fin6.name : '') }}
            {{ (level == 'turnover'? ' / ' + item.content : '') }}
          </v-btn>
        </template>
        <template v-slot:item.sumDebtor="{ item }">
          {{ $numberFormat(item.sumDebtor) }}
        </template>
        <template v-slot:item.sumCreditor="{ item }">
          {{ $numberFormat(item.sumCreditor) }}
        </template>
        <template v-slot:item.debtorRemain="{ item }">
          {{ $numberFormat((item.sumDebtor-item.sumCreditor > 0 ? item.sumDebtor-item.sumCreditor : 0)) }}
        </template>
        <template v-slot:item.creditorRemain="{ item }">
          {{ $numberFormat((item.sumCreditor-item.sumDebtor > 0 ? item.sumCreditor-item.sumDebtor : 0)) }}
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6: 3}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('debtor') + ':' : '') }} {{ $numberFormat(totals.debtor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('creditor') + ':' : '') }} {{ $numberFormat(totals.creditor) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('debtorRemain') + ':' : '') }} {{ $numberFormat(totals.debtorRemain) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('creditorRemain') + ':' : '') }} {{ $numberFormat(totals.creditorRemain) }}
            </td>
          </tr>
          <tr
            v-if="$route.name === 'profit&cost'"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="`${isMobile?6: 5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('remain') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:2}`"
              :class="{'v-data-table__mobile-row':isMobile}"
              class="text-center"
              style="font-size: 18px;font-weight: bold"
            >
              {{ (isMobile ? $t('remain') + ':' : '') }} {{ $numberFormat(+totals.creditorRemain - +totals.debtorRemain) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :review-level-prop="level"
            :review-totals-prop="totals"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  export default {
    name: 'Review',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Print,
      autocomplete,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'accountProp', 'mobileShow'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      filterType: 'month',
      filterTypeItems: null,
      excelItems: null,
      getTurnover: false,
      fromFinancialYear: null,
      toFinancialYear: null,
      documentType: null,
      remain: 'debtorCreditor',
      remainItems: [],
      fromMonth: null,
      fromMonthItems: null,
      toMonthItems: null,
      toMonth: null,
      fromDate: null,
      toDate: null,
      printDialog: false,
      deletDialog: false,
      filter: false,
      level: 'group',
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      levelItems: ['group', 'total', 'given', 'detail', 'fin5', 'fin6'],
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      total: null,
      group: null,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      fin5: null,
      fin6: null,
      given: null,
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.accountProp) {
            if (s.value === 'fin4.name' || s.value === 'given.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d, index) => {
          acc.debtor += (d.sumDebtor ? parseFloat(d.sumDebtor) : 0)
          acc.creditor += (d.sumCreditor ? parseFloat(d.sumCreditor) : 0)
          acc.debtorRemain += (+d.sumDebtor - +d.sumCreditor > 0 ? +d.sumDebtor - +d.sumCreditor : 0)
          acc.creditorRemain += (+d.sumCreditor - +d.sumDebtor > 0 ? +d.sumCreditor - +d.sumDebtor : 0)
          return acc
        }, {
          debtor: 0,
          creditor: 0,
          debtorRemain: 0,
          creditorRemain: 0,
        })
        return totals
      },
    },
    watch: {
      level (val, oldVal) {
        if (val === 'back') {
          this.backLevel(oldVal)
        } else {
          this.getItems()
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'review') {
        this.type = 'review'
      }
      if (this.$route.name === 'profit&cost') {
        this.type = 'profit&cost'
      }
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'reviewContent',
        },
        {
          text: this.$t('debtorTurnover'),
          sortable: false,
          value: 'sumDebtor',
          table: 'doc_article.debtor',
        },
        {
          text: this.$t('creditorTurnover'),
          sortable: false,
          value: 'sumCreditor',
        },
        {
          text: this.$t('debtorRemain'),
          sortable: false,
          value: 'debtorRemain',
        },
        {
          text: this.$t('creditorRemain'),
          sortable: false,
          value: 'creditorRemain',
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.fin4Prop) {
        // const selectedHeaders = app.headers.findIndex(h => h.value === value)
      }
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.remainItems = [
        {
          value: 'debtorCreditor',
          text: this.$t('debtor') + ' ' + this.$t('creditor'),
        },
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
        {
          value: 'zero',
          text: this.$t('zero'),
        },
      ]
      this.filterTypeItems = [
        {
          value: 'month',
          text: this.$t('month'),
        },
        {
          value: 'date',
          text: this.$t('date'),
        },
      ]
    },
    mounted () {
      this.fromFinancialYear = this.$store.state.financialYear
      this.toFinancialYear = this.$store.state.financialYear
      this.getItems()
    },
    methods: {
      setLevel (item) {
        this.getTurnover = false
        switch (this.level) {
          case 'group':
            this.level = 'total'
            this.group = [{ id: item.groupId, name: item.groupName }]
            break
          case 'total':
            this.level = 'given'
            this.total = [{ id: item.totalId, name: item.totalName }]
            break
          case 'given':
            this.level = 'detail'
            this.given = [{ id: item.givenId, name: item.givenName }]
            break
          case 'detail':
            if (!item.fin5_id) {
              this.getTurnover = true
            } else {
              this.level = 'fin5'
              if (item.fin4) {
                this.fin4 = [{ id: item.fin4_id, name: (item.fin4 ? item.fin4.name : '') }]
              }
            }
            break
          case 'fin5':
            if (!item.fin6_id) {
              this.getTurnover = true
            } else {
              this.level = 'fin6'
              if (item.fin5) {
                this.fin5 = [{ id: item.fin5_id, name: (item.fin5 ? item.fin5.name : '') }]
              }
            }
            break
          case 'fin6':
            this.getTurnover = true
            break
          default:
            this.level = 'fin6'
            this.getTurnover = false
        }
        if (this.getTurnover) {
          this.turnover(item)
        }
        // this.getItems()
      },
      backLevel (level) {
        this.getTurnover = false
        if (level === 'group') {
          this.level = 'group'
        }
        if (level === 'total') {
          this.group = null
          this.level = 'group'
        }
        if (level === 'given') {
          this.total = null
          this.level = 'total'
        }
        if (level === 'detail') {
          this.given = null
          this.level = 'given'
        }
        if (level === 'fin5') {
          this.fin4 = null
          this.level = 'detail'
        }
        if (level === 'fin6') {
          this.fin5 = null
          this.level = 'fin5'
        }
        if (level === 'turnover') {
          this.level = 'fin6'
          this.fin6 = null
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.head_id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accountingreport', {
          params: {
            remain: app.remain,
            documentType: app.documentType,
            fromFinancialYear: (app.fromFinancialYear ? app.fromFinancialYear.id : null),
            toFinancialYear: (app.toFinancialYear ? app.toFinancialYear.id : null),
            fromMonth: app.fromMonth,
            toMonth: app.toMonth,
            detail: app.fin4,
            fin5: app.fin5,
            fin6: app.fin6,
            given: app.given,
            account: app.accountProp,
            group: app.group,
            branch: app.branch,
            total: app.total,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            fromDate: app.fromDate,
            toDate: app.toDate,
            refId: app.refId,
            level: app.level,
            type: app.type,
            report: 'review',
            sortBy: app.sortBy,
            groupType: (app.type === 'profit&cost' ? 'costBenefit' : null),
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      turnover (item) {
        if (!item.fin4 && this.getTurnover) {
          this.$router.push({ name: 'turnoverDetail', params: { givenProp: { id: item.givenId, name: item.givenName }, tabName: item.givenName } })
        } else {
          if (this.level === 'detail') {
            this.$router.push({ name: 'turnoverDetail', params: { id: item.fin4_id, givenProp: { id: item.givenId, name: item.givenName }, accountProp: { id: item.fin4_id, name: item.fin4.name }, tabName: item.fin4.name } })
          }
          if (this.level === 'fin5') {
            this.$router.push({ name: 'turnoverDetail', params: { id: item.fin4_id, givenProp: { id: item.givenId, name: item.givenName }, fin5Prop: { id: item.fin5_id, name: item.fin5.name }, tabName: item.fin5.name } })
          }
          if (this.level === 'fin6') {
            this.$router.push({ name: 'turnoverDetail', params: { id: item.fin4_id, givenProp: { id: item.givenId, name: item.givenName }, fin6Prop: { id: item.fin6_id, name: item.fin6.name }, fin5Prop: { id: item.fin5_id, name: item.fin5.name }, tabName: item.fin6.name } })
          }
        }
      },
      givenTurnover (item) {
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d, index) {
          app.excelItems.push({
            row: index + 1,
            content: d.groupName + ' ' + (app.level !== 'group' ? ' / ' + d.totalName : '') + ' ' + (app.level !== 'group' && app.level !== 'total' ? ' / ' + d.givenName : '') + ' ' + (app.level !== 'group' && app.level !== 'total' && app.level !== 'given' && app.level === 'detail' && d.fin4 ? ' / ' + d.fin4.name : ''),
            fin4_name: (d.fin4 ? d.fin4.name : null),
            fin4_id: (d.fin4 ? d.fin4.id : null),
            debtor: d.sumDebtor,
            creditor: d.sumCreditor,
            remainDebtor: (+d.sumDebtor - +d.sumCreditor > 0 ? +d.sumDebtor - +d.sumCreditor : 0),
            remainCreditor: (+d.sumCreditor - +d.sumDebtor > 0 ? +d.sumCreditor - +d.sumDebtor : 0),
          })
        })
      },
    },
  }
</script>

<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.border-datatable
 .theme--light.v-data-table
   .v-data-table__wrapper
     table
       thead
         tr:last-child
           th
             border-top : 1px solid #e3e3e3 !important
             border-left : 1px solid #e3e3e3 !important
             padding : 0px 8px !important
             background-color: #f5f5f5

 .theme--light.v-data-table
   .v-data-table__wrapper
     table
       thead
         tr:last-child
           th:first-child
             border-right : 1px solid #e3e3e3 !important

 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
   border-left : 1px solid #e3e3e3 !important
   padding : 0px 8px !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row):first-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
   border-right : 1px solid #e3e3e3 !important
   padding : 0px 8px !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:first-child:not(.v-data-table__mobile-row)
   border-right : 1px solid #e3e3e3 !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:last-child:not(.v-data-table__mobile-row)
   border-left : 1px solid #e3e3e3 !important

.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot
  min-height: 32px !important

</style>
